module.exports = __webpack_public_path__ + "static/media/check_white_192x192.edd24963.svg";